export const toLocalDate = (date: Date) => ({
  year: date.getFullYear(),
  month: date.getMonth() + 1,
  day: date.getDate(),
});

export const formatDateToString = (date: Date): string => `${String(date.getDate())
  .padStart(2, '0')}.${String(date.getMonth() + 1)
  .padStart(2, '0')}.${date.getFullYear()}`;
